import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownButtonItem } from './dropdown-button-item';

@Component({
  selector: 'app-dropdown-button',
  standalone: true,
  imports: [NgFor, NgbDropdownModule],
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownButtonComponent {
  @Input() leftIconSrc: string = '';
  @Input() dropdownItems: DropdownButtonItem[] = [];
  @Output() itemSelected = new EventEmitter<DropdownButtonItem>();

  public isOpened = false;
}
